import { render } from "./ProdutosLoja.vue?vue&type=template&id=a8206a44"
import script from "./ProdutosLoja.vue?vue&type=script&lang=js"
export * from "./ProdutosLoja.vue?vue&type=script&lang=js"
script.render = render

export default script